import React from "react";
import "./QuantumLoader.css";

interface QuantumLoaderProps {
  startAngle?: number;
  size?: number;
  absolute?: boolean;
}

const QuantumLoader: React.FC<QuantumLoaderProps> = ({
  startAngle = 180,
  size = 50,
  absolute = false,
}) => {
  const r = 35;
  const cx = 45;
  const cy = 45;

  const rad = (startAngle * Math.PI) / 180;
  const x = cx + r * Math.cos(rad);
  const y = cy + r * Math.sin(rad);

  const xOpp = cx - r * Math.cos(rad);
  const yOpp = cy - r * Math.sin(rad);

  const pathData = `M ${x.toFixed(2)} ${y.toFixed(2)} A ${r} ${r} 0 1 1 ${xOpp.toFixed(2)} ${yOpp.toFixed(2)} A ${r} ${r} 0 1 1 ${x.toFixed(2)} ${y.toFixed(2)}`;

  return (
    <div
      className={`quantum-loader-container ${absolute ? "absolute-centered" : ""}`}
      style={{ width: `${size}px`, height: `${size}px` }}
    >
      <svg
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        className="quantum-logo"
      >
        <defs>
          <mask id="circle-gap-mask" maskUnits="userSpaceOnUse">
            <rect x="-20" y="-20" width="140" height="140" fill="white" />

            <line
              x1="65"
              y1="45"
              x2="85"
              y2="65"
              stroke="black"
              strokeWidth="8"
              strokeLinecap="round"
            />
          </mask>
        </defs>

        <path
          className="quantum-circle"
          d={pathData}
          stroke="#3850A0"
          strokeWidth="17"
          fill="none"
          mask="url(#circle-gap-mask)"
        />

        <polygon
          className="quantum-tail"
          points="46,46 61,46 96,81 96,96 81,96 46,61"
        />
      </svg>
    </div>
  );
};

export default QuantumLoader;
